import React from 'react';
import Login from './components/Login/Login';
import Navbar from './components/header/Navbar/Navbar';
import { Container } from 'semantic-ui-react'
import {auth} from './firebase'
//import {Inicio, Nosotros, Contacto, Servicios, Web} from './pages/Web/Web';
//import Tablero from './pages/Dashboard/tablero'

import Nosotros from './pages/Web/nosotros';
import Inicio from './pages/Web/inicio';
import Servicios from './pages/Web/servicios';
import Info from './pages/Web/info';
import Contacto from './pages/Web/contacto'
import terminosycondiciones from './pages/Web/terminosycondiciones';
import Page404 from './pages/Page404';
import Footer from './components/Footer';
import Fotterpage from './components/Fotterpage/Fotterpage';
import Registro from './components/Login/Registro';
import DashBoard from './pages/Dashboard';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Micuenta from './pages/Dashboard/micuenta';
import Tablero from './pages/Dashboard/Tablero';
import Mensaje from './pages/Dashboard/Mensaje';
import Soporte from './pages/Dashboard/Soporte'
import Express from './pages/Dashboard/Express';
import MiniCart from './components/Cart/MiniCart';

import Direcciones from './pages/Dashboard/Direcciones';
import AddUser from './pages/Dashboard/AddUser';
import Companies from './pages/Dashboard/Companies';
import BranchOffc from './pages/Dashboard/BranchOffc';
import Administrators from './pages/Dashboard/Administrators';
import Users from './pages/Dashboard/Users';
import Maps from './pages/Dashboard/Maps';
import Drivers from './pages/Dashboard/Drivers';

import Dispatchs from './pages/Dashboard/Dispatchs';
import Guias from './pages/Dashboard/Guias';
import Rutas from './pages/Dashboard/Rutas';
import Serviciosdash from './pages/Dashboard/Serviciosdash';
import Seleccioneplan from './pages/Dashboard/Serviciosdash/Seleccioneplan.jsx';

import Configuraciones from './pages/Dashboard/Configuraciones';
import Seguridad from './pages/Dashboard/Seguridad';
import ReportBug from './pages/Dashboard/ReportBug';
import Ecobicci from './pages/Web/ecobicci/Ecobicci';
import Traking from './pages/Dashboard/Traking';
import Dispatchdetails from './components/Dispatchdetails';
import ScrollToTop from './components/animations/ScrollToTop';
import useTitle from './components/Seo/useTitle';
import useSeo from './components/Seo/useSeo';
import Recuperarcuenta from './components/Login/Recuperarcuenta';
import Products from './components/Products/Products';
import Productdetails from './components/Productdetails';
import Checkout from './components/Checkout'
import thanksyou from './components/Checkout/thanksyou.jsx'
import Billing from './pages/Dashboard/Billing/Billing';
import Seleccionbilling from './pages/Dashboard/Billing/Seleccionbilling';
import SeleccionCompany from './pages/Dashboard/Billing/SeleccionCompany';
import { cerrarSesionAccion } from './redux/usuarioDucks';
import {useDispatch } from 'react-redux'
import Installer from './components/Installer/Installer';
import useGlobalConfig from './hooks/globalConfig';
import Seleccionepack from './pages/Dashboard/Serviciosdash/Seleccionepack';
import Cart from './components/Cart/Cart';
import Validacionbilling from './pages/Dashboard/Billing/Validacionbilling';
import DashDispatchsAdd from './components/ManagementRoutes/DashDispatchs/DashDispatchsAdd/DashDispatchsAdd';
import DashDispatchs from './components/ManagementRoutes/DashDispatchs/DashDispatchs';
import DashDispatchsEdit from './components/ManagementRoutes/DashDispatchs/DashDispatchsEdit/DashDispatchsEdit';
import DashDispatchsNew from './components/ManagementRoutes/DashDispatchs/DashDispatchsNew/DashDispatchsNew';
import DashRoutesAdd from './components/ManagementRoutes/DashRoutes/DashRoutesAdd/DashRoutesAdd';
import DashRoutesNew from './components/ManagementRoutes/DashRoutes/DashRoutesNew/DashRoutesNew';
import DashRoutesEdit from './components/ManagementRoutes/DashRoutes/DashRoutesEdit/DashRoutesEdit';
import DashRoutes from './components/ManagementRoutes/DashRoutes/DashRoutes';
import Fleet from './pages/Dashboard/Fleet/Fleet';


function App() {
  const {siteName} = useGlobalConfig()
  const dispatch = useDispatch()
  const [firebaseUser, setFirebaseUser] = React.useState(false)
  const [showMinicart,setShowMinicart ] = React.useState(false)
  useTitle({title:`${siteName} CHILE`})
  useSeo({description:'Empresa de logística y transporte comprometida con el desarrollo social en chile, que busca ayudar al medio ambiente por medio de la tecnología y la electromovilidad de nuestros vehículos, reduciendo la huella de carbono en la ciudad,Aumenta tus ventas a través de diferentes canales de delivery con ubicaciones estratégicas. Haz que tu negocio venda más por delivery apps, sin tiendas físicas en todas las comunas'})

  React.useEffect(() => {
    const fetchUser = () => {
      auth.onAuthStateChanged(user => {
         // console.log(user)
          if(user){
              setFirebaseUser(user)
          }else{
              setFirebaseUser(null)
          }
    
      })
    }
    fetchUser()
    
  }, [firebaseUser])



  const RutaPrivada = ({props, component, path, setFirebaseUser, ...rest}) => {
  
    if(localStorage.getItem('usuario')){
      const usuarioStorage = JSON.parse(localStorage.getItem('usuario'))
      
  

      try {
        // console.log(usuarioStorage.uid)
        // console.log(firebaseUser.uid)
      } catch (error) {
        console.log(`Error: ${error}`) // ReferenceError: p is not defined 
        dispatch(cerrarSesionAccion())
        return <Redirect to="/" {...rest} />

      }
      
      if(usuarioStorage.uid === firebaseUser.uid){
        return <Route component={component} path={path} {...rest} />
        
      }else{
        return <Redirect to="/login" {...rest} />
      }

    }else{
      return <Redirect to="/login" {...rest} />
    }
  
  }

  const handleShowMinicart = () => {
    setShowMinicart(!showMinicart)
  }
  const handleclosedminicart = () => {
    setShowMinicart(!showMinicart)
  }




  
  return firebaseUser !== false ? (
    <Router>
      <ScrollToTop/>
      <div >
      <Container fluid className='topbar topcontainer' >
      <Navbar handleshowminicart={handleShowMinicart}/>
      </Container>

      <div className='bodycontainer bodycontainerdahs' >
      {
      showMinicart?(<MiniCart handleclosedminicart={handleclosedminicart}/>):(<></>)
      }
        <Switch>
          <Route component={Inicio} path="/" exact/>
          <Route component={Installer} path="/installer" exact/>
          <Route component={Inicio} path="/inicio" exact/>
          <Route component={Traking} path="/traking" exact/>
          <Route component={Nosotros} path="/nosotros" />
          <Route component={Traking} path="/consulta-envio" />
          <Route component={Ecobicci} path="/eco-bicci" exact/>
          <Route component={Products} user={firebaseUser}  path="/productos" exact/>
          <Route component={Productdetails} path="/productos/:slugs" />
          <Route component={Cart} user={firebaseUser}  path="/cart" exact/>
          {/* <Route component={Products} path="/cart" exact/> */}
          <Route component={Servicios} path="/servicios" />
          <Route component={Info} path="/info" />
          <Route component={Contacto} path="/contacto" />
          <Route component={Login} path="/login" />
          <Route component={Recuperarcuenta} path="/recuperar-cuenta" />
          <Route component={Registro} path="/registro" />
          <Route component={terminosycondiciones} path="/terminos" />  

          <RutaPrivada component={DashBoard} path="/dashboard" exact/>
          <DashBoard component={Tablero} path="/dashboard/tablero" exact/>
          <DashBoard component={Express} path="/dashboard/envios-express" exact/>

          <DashBoard component={Micuenta} path="/dashboard/mi-cuenta" exact/>

          <DashBoard component={Direcciones} path="/dashboard/direcciones" exact/>
          <DashBoard component={AddUser} path="/dashboard/usuarios" exact/>

          <DashBoard component={Companies} path="/dashboard/companies" exact/>
          <DashBoard component={BranchOffc} path="/dashboard/stores" exact/>
          <DashBoard component={Administrators} path="/dashboard/administrators" exact/>
          <DashBoard component={Users} path="/dashboard/users" exact/>

          <DashBoard component={Maps} path="/dashboard/maps" exact/>
          <DashBoard component={Drivers} path="/dashboard/drivers" exact/>
          <DashBoard component={Drivers} path="/dashboard/vehicles" exact/>
          <DashBoard component={Dispatchs} path="/dashboard/creartedispatch" exact/>
          <DashBoard component={Fleet} path="/dashboard/fleet" exact/>
          <DashBoard component={Dispatchs} path="/dashboard/dispatch" exact/>

          <DashBoard component={Dispatchdetails} path="/dashboard/dispatch/details/:id" exact/>

          <DashBoard component={Guias} path="/dashboard/guias" exact/>
          <DashBoard component={DashDispatchs} path="/dashboard/guias/details/:id" exact/>
          <DashBoard component={DashDispatchsEdit} path="/dashboard/guias/:id/edit" exact/>
          <DashBoard component={DashDispatchsNew} path="/dashboard/guias/new" exact/>
          <DashBoard component={DashDispatchsAdd} path="/dashboard/guias/add" exact/>


          <DashBoard component={Rutas} path="/dashboard/routes" exact/>
          <DashBoard component={DashRoutes} path="/dashboard/route/details/:id" exact/>
          <DashBoard component={DashRoutesEdit} path="/dashboard/route/:id/edit" exact/>
          <DashBoard component={DashRoutesNew} path="/dashboard/routes/new" exact/>
          <DashBoard component={DashRoutesAdd} path="/dashboard/route/:id/dispatches" exact/>


          <DashBoard component={Dispatchdetails} path="/dashboard/:idcompanies/dispatchs/" exact/>
          <DashBoard component={Dispatchdetails} path="/dashboard/:idcompanies/dispatch/details/:id" exact/>

          <DashBoard component={Serviciosdash} path="/dashboard/servicios" exact/>
          <DashBoard component={Seleccionepack} path="/dashboard/servicios/seleccione_pack" exact/>
          <DashBoard component={Seleccioneplan} path="/dashboard/servicios/seleccione_plan" exact/>

          <DashBoard component={Configuraciones} path="/dashboard/settings" exact/>
          <DashBoard component={Seguridad} path="/dashboard/seguridad" exact/>
          <DashBoard component={ReportBug} path="/dashboard/report-bugs" exact/>
          <DashBoard component={ReportBug} path="/dashboard/manager-bug" exact/>

          <DashBoard component={Mensaje} path="/dashboard/mensaje" exact/>
          <DashBoard component={Mensaje} path="/dashboard/manager-mensajes" exact/>
          <DashBoard component={Soporte} path="/dashboard/soporte" exact/>
          <DashBoard component={Soporte} path="/dashboard/manager-soporte" exact/>
          

          <RutaPrivada component={Mensaje} path="/mensaje" exact/>
          <RutaPrivada component={Micuenta} path="/mi-cuenta" exact/>
          <RutaPrivada component={Soporte} path="/soporte" exact/>

          <Route component={Checkout} path="/checkout/login" exact/>
          <Route component={Checkout} path="/checkout" exact/>
          <RutaPrivada component={thanksyou} path="/checkout/thanksyou" exact/>

          <RutaPrivada component={Billing} path="/billing/" exact/>
          <RutaPrivada component={SeleccionCompany} path="/billing/:company" exact/>

          <RutaPrivada component={Seleccionbilling} path="/billing/:company/:id" exact/>
          <RutaPrivada component={Validacionbilling} path="/billing/validacion/:company/:id" exact/>
   
          <RutaPrivada component={Checkout} path="/checkout/payments" exact/>
          <RutaPrivada component={Checkout} path="/checkout/desktopSingleReview" exact/>

          <Route component={Page404} />
        </Switch>
        <Fotterpage/>
      </div>
     
      </div>
      <Footer/>
    </Router>
   
    
  ) : (<div>Cargando...</div>)
}

export default App;
